module.exports = __webpack_public_path__ + "static/lbw-4e0768685f19df49ed6e8ccb8bf59f59.jpg";